'use client';

import { useEffect } from 'react';
import { captureException, addBreadcrumb } from '@/utils/sentry';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (error.digest) {
      addBreadcrumb({ message: `Error digest: ${error.digest}`, category: 'error', level: 'error' });
    }
    captureException(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md space-y-4">
        <h1 className="text-4xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground">
          We hit an unexpected error. Our team has been notified.
        </p>
        {error.digest && (
          <p className="text-xs text-muted-foreground">
            Reference: <code>{error.digest}</code>
          </p>
        )}
        <div className="flex gap-3 justify-center pt-2">
          <button
            onClick={() => reset()}
            className="px-4 py-2 bg-primary text-primary-foreground rounded hover:opacity-90"
          >
            Try again
          </button>
          <a
            href="/"
            className="px-4 py-2 border rounded hover:bg-muted"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}
